/**
 * Created by noghan odedra on 01/04/18.
 */

define(function (require, exports, module) {

    'use strict';

    module.exports = function (uuid, $timeout) {

        function getTemplate(element, attrs) {
            return `
                  <div class="file-selector">

	                  <div class="field-row">
		                  <div class="upload-info">
			                  <label for="file" class="field-title" lp-i18n="{{chooseFileLabelText}}"></label>
			                  <div class="fileUpload btn">
				                  <input name="file" type="file" class="upload" />
				                  <span class="visible-xs" lp-i18n="abc.common.select.file"></span>
				                  <div class="hidden-xs">
					                  <span class="drop-file" lp-i18n="abc.common.drag.drop.file"></span>
					                  <span> </span>
					                  <span class="select-file" lp-i18n="abc.common.or.select.file"></span>
				                  </div>
				                  <p class="file-type">
                            <span ng-if="uploadInstructionsText2" lp-i18n="{{uploadInstructionsText2}}" class="instruction-message"/>
                            <span lp-i18n="{{uploadInstructionsText}}"/>
                            <span ng-if="uploadError" class="file-error" lp-i18n="{{errorMessage}}"></span>
                          </p>
			                  </div>
		                  </div>
	                  </div>

	                  <div class="row">
	                        <div  class="col-xs-12 sm-6 col-sm-12 uploaded-file-list-wrap">
	                          <div ng-show="files && files.length > 0" class="file-info uploaded-file-list-title">
	                            <div class="file-name-title" lp-i18n="abc.common.name"></div>
	                            <div class="file-name-size" lp-i18n="abc.common.size"></div>
	                            <div class="file-name-type" lp-i18n="abc.common.type"></div>
	                            <div class="file-delete-title">&nbsp;</div>
	                          </div>
	                          <div class="file-info clear-both" ng-class="item.isError ? 'file-info-error' : 'file-info-success' " ng-repeat="file in files">
	                            <div class="file-name" title="{{file.name}}">
	                              {{ file.name }}
	                            </div>
	                            <div class="file-size">
	                              {{ file.size/(1024*1024)|number:2 }} <span lp-i18n="abc.common.mb"></span>
	                            </div>
	                            <div class="file-size">
	                              {{getFileType(file)}}
	                            </div>
	                            <div class="file-delete-icon">
		                             <span ng-if="showDeleteButton === true || showDeleteButton === 'true'">
		                                  <em class="fa-times-thin fa-3x" aria-hidden="true" ng-click="removeFile(file)"></em>
		                             </span>
	                            </div>
	                          </div>
	                        </div>
	                  </div>
	                </div>
                  `
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                selectedFiles: '=',
                allowedFileExtensions: '@', //set comma separated string as value of this field
                chooseFileLabelText: '@',
                uploadInstructionsText: '@',
                uploadInstructionsText2: '@',
                showDeleteButton: '@',
                maxFiles: '@',
                maxFileSizeMb: '@',
                validationMessagesMap: '=',
                onError: '&',
                onFileAdded: '&',
                onFileRemoved: '&',
                onFileLoadingComplete: '&'
            },
            template: getTemplate,
            compile: function (tElement, tAttrs, transclude) {
                let fileInput = angular.element(tElement[0].querySelector("input[type='file']"));
                if (!tAttrs.maxFiles) {
                    tAttrs.maxFiles = 1;
                    fileInput.removeAttr("multiple")
                } else {
                    fileInput.attr("multiple", "multiple");
                }

                if (!tAttrs.maxFileSizeMb) {
                    tAttrs.maxFileSizeMb = 1;
                }

                let fileId = uuid.new();
                fileInput.attr("id", fileId);

                return function (scope, el, attrs, ctl) {
                    const TOO_MANY_FILES = "TOO_MANY_FILES";
                    const INVALID_EXTENSION = "INVALID_EXTENSION";
                    const MAX_SIZE_EXCEEDED = "MAX_SIZE_EXCEEDED";
                    const ALREADY_EXISTS = "ALREADY_EXISTS";

                    const DEFAULT_VALIDATION_MESSAGES_MAP = {
                        TOO_MANY_FILES: "Can not upload more then allowed files limit which is " + scope.maxFiles,
                        INVALID_EXTENSION: "Files are uploaded with extensions which are not allowed. Valid extensions are: " + scope.allowedFileExtensions,
                        MAX_SIZE_EXCEEDED: "Files are larger than the specified max size (" + scope.maxFileSizeMb + " MB)",
                        ALREADY_EXISTS: "File(s) already uploaded."
                    };
                    Object.freeze(DEFAULT_VALIDATION_MESSAGES_MAP);
                    const defaultAllowedExtensions = ['pdf', 'txt'];

                    const validationMessagesMap = (scope.validationMessagesMap != undefined && scope.validationMessagesMap != '') ? scope.validationMessagesMap : DEFAULT_VALIDATION_MESSAGES_MAP;
                    scope.uploadError = false;
                    scope.errorMessage = "";

                    scope.$watch('selectedFiles', function (selectedFiles) {
                        scope.files = selectedFiles;
                        $timeout(function () {
                            scope.uploadError = false;
                        }, 100);
                        if (selectedFiles && selectedFiles.length > 0)
                            resetFileInput();
                    });

                    let validFileExtensions = (scope.allowedFileExtensions) ? scope.allowedFileExtensions.split(',') : defaultAllowedExtensions;
                    if (validFileExtensions) {
                        let arrayLength = validFileExtensions.length;
                        for (let i = 0; i < arrayLength; i++) {
                            validFileExtensions[i] = validFileExtensions[i].toLowerCase();
                        }
                    }

                    scope.getFileExtension = function (file) {
                        let extension = file.name.substr(file.name.lastIndexOf('.') + 1);
                        return extension.toLowerCase();
                    };

                    scope.getFileType = function (file) {
                        let extension = scope.getFileExtension(file);
                        return extension.toUpperCase();
                    };

                    scope.getCustomFileData = function (file) {
                        let fileDetails = {};
                        fileDetails.mimeType = file.type;
                        fileDetails.fileExtension = scope.getFileExtension(file);
                        fileDetails.fileName = file.name;
                        return fileDetails;
                    };

                    function findFile(fileName, files) {
                        for (let i = files.length - 1; i >= 0; --i) {
                            if (files[i].name == fileName) {
                                return { 'index': i, 'file': files[i] }
                            }
                        }
                        return undefined;
                    }

                    function resetEventTarget(event) {
                        event.target.value = "";
                        //event.srcElement.value = ""; //hack to allow uploading same file again
                    }

                    scope.removeFile = function (file) {
                        let fileItem = findFile(file.name, scope.files);
                        if (fileItem) {
                            scope.files.splice(fileItem.index, 1);
                            if (scope.onFileRemoved) {
                                scope.onFileRemoved({ file: fileItem.file });
                            }
                        }
                        if (scope.files && scope.files.length === 0) {
                            scope.uploadError = false;
                            scope.errorMessage = "";
                            resetFileInput();
                        }
                    };

                    el.bind('change', function (e) {
                        scope.uploadError = false;
                        scope.errorMessage = "";

                        if (!e.target.files.length) {
                            resetEventTarget(e);
                            return;
                        }

                        let tooBig = [];
                        let invalidExt = [];
                        let fileExists = [];

                        if ((scope.files.length + e.target.files.length) > scope.maxFiles) {
                            raiseError(e.target.files, TOO_MANY_FILES, "Cannot upload " + scope.files.length + " files, maximum allowed is " + scope.maxFiles, e);
                            scope.uploadError = true;
                            scope.errorMessage = validationMessagesMap[TOO_MANY_FILES];
                            scope.$apply(function () { });
                            return;
                        }

                        for (let i = 0; i < scope.maxFiles; i++) {
                            if (i >= e.target.files.length) break;

                            let file = e.target.files[i];
                            let ext = scope.getFileExtension(file);
                            let fileItem = findFile(file.name, scope.files);
                            if (file.size > scope.maxFileSizeMb * 1048576) {
                                tooBig.push(file);
                            } else if (validFileExtensions && validFileExtensions.indexOf(ext) == -1) {
                                invalidExt.push(file);
                            }
                            else if (fileItem && fileItem.file) {
                                fileExists.push(file);
                            }
                            else {
                                if (file) {
                                    scope.files.push(file);
                                    if (scope.onFileAdded) {
                                        scope.onFileAdded({ file: file });
                                    }
                                    let reader = new FileReader();
                                    reader.readAsDataURL(file);
                                    reader.onload = function (e) {
                                        // browser completed reading file - display it
                                        let fileDetails = scope.getCustomFileData(file);
                                        let base64result = e.target.result.split(',')[1];
                                        fileDetails.fileData = base64result;
                                        if (scope.onFileLoadingComplete) {
                                            scope.onFileLoadingComplete({ fileDetails: fileDetails });
                                        }
                                    };
                                }
                            }
                        }

                        if (invalidExt.length > 0) {
                            raiseError(invalidExt, INVALID_EXTENSION, "Files are upload with extensions which are not allowed. Valid extensions are: " + scope.allowedFileExtensions, e);
                            scope.uploadError = true;
                            scope.errorMessage = validationMessagesMap[INVALID_EXTENSION];
                            scope.$apply(function () { });
                            return;
                        }
                        if (tooBig.length > 0) {
                            raiseError(tooBig, MAX_SIZE_EXCEEDED, "Files are larger than the specified max (" + scope.maxFileSizeMb + "MB)", e);
                            scope.uploadError = true;
                            scope.errorMessage = validationMessagesMap[MAX_SIZE_EXCEEDED];
                            scope.$apply(function () { });
                            return;
                        }
                        if (fileExists.length > 0) {
                            raiseError(fileExists, ALREADY_EXISTS, "File(s) already uploaded.", e);
                            scope.uploadError = true;
                            scope.errorMessage = validationMessagesMap[ALREADY_EXISTS];
                            scope.$apply(function () { });
                            return;
                        }
                        resetEventTarget(e);
                        scope.$apply(function () { });
                    });

                    function raiseError(files, type, msg, event) {
                        if (scope.onError) {
                            scope.onError({ files: files, type: type, msg: msg });
                        }
                        resetEventTarget(event);
                        //resetFileInput();
                    }

                    function resetFileInput() {

                        fileInput.remove();
                        let input = document.createElement("input");
                        let attr = document.createAttribute("type");
                        attr.nodeValue = "file";
                        input.setAttributeNode(attr);

                        let inputId = uuid.new();
                        attr = document.createAttribute("id");
                        attr.nodeValue = inputId;
                        input.setAttributeNode(attr);

                        attr = document.createAttribute("style");
                        attr.nodeValue = "opacity: 0;display:inline;width:0";
                        input.setAttributeNode(attr);

                        attr = document.createAttribute("class");
                        attr.nodeValue = "upload";
                        input.setAttributeNode(attr)

                        if (scope.maxFiles > 1) {
                            attr = document.createAttribute("multiple");
                            attr.nodeValue = "multiple";
                            input.setAttributeNode(attr);
                        }

                        fileInput = angular.element(input);
                        if (fileInput) {
                            fileInput.value = '';
                        }
                    }
                }
            }
        }

    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/directives/file-selector.js
// module id = 5
// module chunks = 0